import React from 'react';

import {AppContext} from '../../../AppModule/Context';

import AnimatedSvgLogo from '../../common/genericComponents/animatedSvgLogo';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';

import VIDABOO_CONSTANTS from '../../../config/consts';
import messenger from '../../../assets/svg/messenger-redesign.svg';

import './messengerComponent.css';

class MessengerComponent extends React.Component {
  sendFbMessage = () => {
    // console.debug("sendFB message here is");
    this.props.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_FB_MESSAGE,
    );
    this.props.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_FB_MESSAGE,
    );
    let mentorFbLink =
      'https://m.me/' + this.props.mentor.mentorDto.fbMessengerLink;
    // var mentorFbLink = "https://m.me/" + fbMessengerLink;
    window.open(mentorFbLink, '_blank');
  };

  render() {
    return (
      <div
        className={
          this.props.isPersonalPage
            ? 'et-personal-page-right-content-wrap'
            : 'et-widget-body-content-wrap'
        }>
        <div
          className={`et-v2-messenger-container ${this.props.isPersonalPage ? 'et-v2-pp-messenger-container' : ''}`}>
          <div
            className="et-v2-messenger-icon-text-wrap"
            onClick={() => {
              this.sendFbMessage();
              this.props.callSendMessageFunc(
                'Facebook Messenger',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.MESSENGER_MESSAGE,
              );
            }}>
            {this.props.showNewUI ? (
              <div className="et-v2-messenger-animated-svg-logo-wrap">
                <AnimatedSvgLogo
                  type={VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.MESSENGER}
                />
              </div>
            ) : (
              <img
                className="et-v2-mc-icon-img"
                src={messenger}
                alt="messenger-icon"
              />
            )}
            <div className="et-v2-messenger-inner-txt">
              {this.props?.mentor?.mentorDto?.appControlDto
                ?.widgetEditableTexts[
                VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER
              ] || (
                <>
                  Let's start <br /> Facebook chat
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={`et-v2-widget-btn-wrap ${this.props.isPersonalPage ? 'et-v2-clickntalk-btn-wrap' : ''}`}>
          <ButtonComponent
            onClick={() => {
              this.sendFbMessage();
              this.props.callSendMessageFunc(
                'Facebook Messenger',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.MESSENGER_MESSAGE,
              );
            }}
            image={
              this.props.isPersonalPage ? (
                <div className="et-v2-messenger-btn-img">
                  <CommunicationIcons.MessengerIcon fillColor="#fff" />
                </div>
              ) : null
            }
            text={
              (this.props.mentor.mentorDto.appControlDto.widgetEditableTexts &&
                this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
                  VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT.FB_MESSENGER
                ]) ||
              this.context.languageSet.CONSOLTO_WIDGET.START_CHAT
            }
          />
        </div>
      </div>
    );
  }
}

MessengerComponent.contextType = AppContext;
export default MessengerComponent;
